import { Avatar, AvatarProps } from '../Avatar';
import { getLiquidityProviderLogoSrc } from './liquidityProviderLogos';

export type LiquidityProviderAvatarProps = AvatarProps & {
  /**
   * Name of the liquidity provider to display the logo for.
   */
  name: string;
};

export const liquiditySourceAvatarRadius = '32%';

export const LiquidityProviderAvatar = (props: LiquidityProviderAvatarProps) => {
  const { name, size = 20, ...otherProps } = props;

  const src = getLiquidityProviderLogoSrc(name);

  return (
    <Avatar src={src} radius={liquiditySourceAvatarRadius} size={size} {...otherProps}>
      <div
        className="flex items-center justify-center bg-token-gray-200"
        style={{ width: size, height: size }}
      >
        <p className="text-token-gray-1000">{name.charAt(0).toUpperCase()}</p>
      </div>
    </Avatar>
  );
};
